module.exports = __webpack_public_path__ + "static/media/mysql.94821cfe.png";